import { render } from "./PersonalAccountScreen.vue?vue&type=template&id=113c41f8"
import script from "./PersonalAccountScreen.vue?vue&type=script&lang=js"
export * from "./PersonalAccountScreen.vue?vue&type=script&lang=js"

import "./PersonalAccountScreen.vue?vue&type=style&index=0&id=113c41f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__